<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Remerciements</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">À MES</span> bien-aimés Cinq, Penn, Tamm, Lea et Jenn. Vous avez toujours été mes étoiles à travers les épreuves, petites et grandes, les dangers inconnus et le reste. Vous êtes ma constellation et je n’oublierai jamais nos querelles et nos fous rires à propos du thé.</p>
<p class="P_Normal">Beaucoup d’affection et d’amour pour mes autres frères et sœurs, Ren, Ree, Mary et Lisa. Et bien sûr le San Diego Crewe – Andy, Steve, Maite et Felix.</p>
<p class="P_Normal">Merci comme toujours à Dreamspinner – Elizabeth, Lynn, Naomi (qui endure ma folie), Liz et son équipe, tous ceux et celles qui travaillent si dur pour améliorer ce que je leur envoie. J’ai pour vous une infinie admiration.</p>
<p class="P_Normal">Un hourra spécial à Micah Caudle qui me supporte. Mec, je te dois bien tout le café que tu ingurgiteras de ton vivant.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?44388285